import { render, staticRenderFns } from "./AccountUser.vue?vue&type=template&id=1cb3be65"
import script from "./AccountUser.vue?vue&type=script&lang=js"
export * from "./AccountUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports